import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private toastr: ToastrService, private jwtAuth: jwtAuthService, private router: Router) {}
  // No início da sua classe de componente
  private readonly CHAVE_REDIRECIONAMENTO_COLAB = 'redirectAfterLoginColab';
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //Retorna verdadeiro se tiver token valido
    if (this.jwtAuth.isUsuarioLogado()) {
      return true;
    }

    if (state.url.includes('/cotacao/visualizar/')) {
      return true; // Permite acesso sem autenticação( pdf da proposta - para enviar ao cliente)
    }

    // Salva a URL atual para redirecionamento pós-login
    localStorage.setItem(this.CHAVE_REDIRECIONAMENTO_COLAB, state.url);

    this.router.navigate(['/login']);
    return false;
  }
}
